module.exports = __webpack_public_path__ + "static/media/01_wall_detection.aaa1f85d.png";